var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveandgo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Savings",
    clipPath: "url(#clip0_6017_19711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0156 6.42969H13.0156V3.85156L14.1156 5.08906C14.5156 5.50156 15.1156 5.50156 15.5156 5.08906C15.9156 4.67656 15.9156 4.05781 15.5156 3.64531L12.7156 0.551563C12.3156 0.139063 11.7156 0.139063 11.3156 0.551563L8.51562 3.64531C8.11563 4.05781 8.11563 4.67656 8.51562 5.08906C8.91562 5.50156 9.51562 5.50156 9.91562 5.08906L11.0156 3.85156V6.42969H5.01562C3.41563 6.42969 2.01562 7.77031 2.01562 9.52344V10.5547C0.915625 10.5547 0.015625 11.4828 0.015625 12.6172V14.6797C0.015625 15.8141 0.915625 16.7422 2.01562 16.7422V17.7734C2.01562 19.5266 3.31562 20.8672 5.01562 20.8672H17.0156C18.7156 20.8672 20.0156 19.5266 20.0156 17.7734V9.52344C20.0156 7.77031 18.7156 6.42969 17.0156 6.42969ZM2.01562 12.6172H5.01562C5.61562 12.6172 6.01562 13.0297 6.01562 13.6484C6.01562 14.2672 5.61562 14.6797 5.01562 14.6797H2.01562V12.6172ZM18.0156 17.7734C18.0156 18.3922 17.6156 18.8047 17.0156 18.8047H5.01562C4.41563 18.8047 4.01562 18.3922 4.01562 17.7734V16.7422H5.01562C6.71562 16.7422 8.01562 15.4016 8.01562 13.6484C8.01562 11.8953 6.71562 10.5547 5.01562 10.5547H4.01562V9.52344C4.01562 8.90469 4.41563 8.49219 5.01562 8.49219H11.0156V13.6484C11.0156 14.2672 11.4156 14.6797 12.0156 14.6797C12.6156 14.6797 13.0156 14.2672 13.0156 13.6484V8.49219H17.0156C17.6156 8.49219 18.0156 8.90469 18.0156 9.52344V17.7734Z",
    fill: "#4B5768"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6017_19711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.625,
    fill: "white",
    transform: "translate(0.015625 0.242188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveandgo);
export default __webpack_public_path__ + "static/media/saveandgo.6fb952368300bd4675d0f5f7bd85ab1a.svg";
export { ForwardRef as ReactComponent };